// removed by extract-text-webpack-plugin
module.exports = {"lazyLog":"_3NRgTLvWbyfWD-1xileYWR"};
    if(module.hot) {
      // 1542732365616
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/components/LazyLog/index.module.css
// module id = 16
// module chunks = 0 1